import { render, staticRenderFns } from "./WaybillTagPDF.vue?vue&type=template&id=882995d0&scoped=true&"
import script from "./WaybillTagPDF.vue?vue&type=script&lang=js&"
export * from "./WaybillTagPDF.vue?vue&type=script&lang=js&"
import style0 from "./WaybillTagPDF.vue?vue&type=style&index=0&id=882995d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882995d0",
  null
  
)

export default component.exports